var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { getOrderResult } from "../../../../../data/api";
import { Col, Modal, Row } from "react-bootstrap";
import { Alert, Form, Icon } from "@brushfire/ui";
import WidgetFieldset from "../../../../Helpers/WidgetFieldset";
import FormikContextListener from "../../../../Helpers/FormikContextListener";
import Constants from "../../../../../data/constants";
import { WidgetContext } from "../../../../Widget";
import { useSelector } from "react-redux";
import EventCard from "../../../EventList/EventCard";
import { platformAwareRedirect } from "../../../../../data/helpers";
import { useMediaQuery } from "react-responsive";
var useTypedSelector = useSelector;
var CartResult = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var theme = _a.theme, eventData = _a.eventData, path = _a.path;
    var _j = __read(useState(false), 2), showModal = _j[0], setShowModal = _j[1];
    var _k = __read(useState(), 2), modalContent = _k[0], setModalContent = _k[1];
    var params = useParams();
    var history = useHistory();
    var isAutoRegMode = useTypedSelector(function (store) { return store.app; }).isAutoRegMode;
    var kioskHomeUrl = useTypedSelector(function (store) { var _a; return (_a = store.utilities.kiosk) === null || _a === void 0 ? void 0 : _a.homeUrl; });
    var _l = __read(useState(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    (_d = (_c = (_b = history === null || history === void 0 ? void 0 : history.location) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.orderResult) !== null && _d !== void 0 ? _d : undefined), 2), orderResult = _l[0], setOrderResult = _l[1];
    var _m = __read(useState(), 2), secondsLeft = _m[0], setSecondsLeft = _m[1];
    var isWidget = useContext(WidgetContext).isWidget;
    var isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    var qrUrl = eventData && (orderResult === null || orderResult === void 0 ? void 0 : orderResult.anyGeneratesTicket) && (orderResult === null || orderResult === void 0 ? void 0 : orderResult.orderId)
        ? "https://".concat(process.env.REACT_APP_DOMAIN, "/").concat(eventData.clientKey, "/").concat(eventData.urlKey, "/").concat(eventData.eventNumber, "/tix/").concat(orderResult.orderId, "/code")
        : null;
    var qrLink = (orderResult === null || orderResult === void 0 ? void 0 : orderResult.anyGeneratesTicket) && (orderResult === null || orderResult === void 0 ? void 0 : orderResult.orderId)
        ? "https://".concat(process.env.REACT_APP_DOMAIN, "/tix/").concat(orderResult.orderId.replace(/-/g, ""))
        : null;
    useEffect(function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        window.showConfirmationModal = function (html, title) {
            setModalContent({ title: title, html: html });
            setShowModal(true);
        };
        return function () {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            window.showConfirmationModal = null;
            setShowModal(false);
        };
    }, []);
    useEffect(function () {
        if (history && params.hash && params.hash !== (orderResult === null || orderResult === void 0 ? void 0 : orderResult.orderHash)) {
            getOrderResult(params.hash)
                .then(function (_a) {
                var data = _a.data;
                setOrderResult(data);
            })
                .catch(function (err) {
                debugger;
            });
        }
    }, [history, params.hash]);
    useEffect(function () {
        if ((orderResult === null || orderResult === void 0 ? void 0 : orderResult.kioskTimeoutInSeconds) && !secondsLeft) {
            setSecondsLeft(orderResult.kioskTimeoutInSeconds);
        }
    }, [orderResult === null || orderResult === void 0 ? void 0 : orderResult.kioskTimeoutInSeconds]);
    useEffect(function () {
        var _a, _b;
        if (!orderResult) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            setOrderResult((_b = (_a = history === null || history === void 0 ? void 0 : history.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.orderResult);
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
    }, [(_f = (_e = history === null || history === void 0 ? void 0 : history.location) === null || _e === void 0 ? void 0 : _e.state) === null || _f === void 0 ? void 0 : _f.orderResult]);
    var onSubmit = function (values, formikHelpers) {
        formikHelpers.setSubmitting(false);
        finishOrder();
    };
    var finishOrder = function () {
        var _a, _b, _c, _d, _e, _f;
        if (eventData)
            //try to close widget
            try {
                if ((orderResult === null || orderResult === void 0 ? void 0 : orderResult.anyGeneratesTicket) && isMobile) {
                    var orderId = (_a = orderResult === null || orderResult === void 0 ? void 0 : orderResult.orderId) === null || _a === void 0 ? void 0 : _a.replace(/-/g, "");
                    window.location.assign("https://".concat(process.env.REACT_APP_DOMAIN, "/tix/").concat(orderId));
                }
                else if (isWidget && window.parent && window.parent.location !== window.location) {
                    window.parent.postMessage(JSON.stringify(orderResult.homeUrl
                        ? { action: "redirect", url: orderResult.homeUrl }
                        : { action: "close" }), "*");
                }
                else {
                    window.parent.location.href = kioskHomeUrl
                        ? kioskHomeUrl
                        : (orderResult === null || orderResult === void 0 ? void 0 : orderResult.homeUrl)
                            ? orderResult.homeUrl
                            : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                //@ts-ignore
                                (((_c = (_b = history === null || history === void 0 ? void 0 : history.location) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.postAttendeeOrder)
                                    ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        //@ts-ignore
                                        (_f = (_e = (_d = history === null || history === void 0 ? void 0 : history.location) === null || _d === void 0 ? void 0 : _d.state) === null || _e === void 0 ? void 0 : _e.finishUrl) !== null && _f !== void 0 ? _f : Constants.Routes.myDashboard
                                    : isAutoRegMode
                                        ? Constants.Routes.autoreg
                                        : eventData.verbiage === "Tickets"
                                            ? Constants.Routes.tickets
                                            : Constants.Routes.register)
                                    .replace(":clientKey", eventData.clientKey)
                                    .replace(":urlKey", eventData.urlKey)
                                    .replace(":lookupId?", "")
                                    .replace(":eventNumber", eventData.eventNumber.toString());
                }
                //otherwise, redirect to beginning after 2 seconds
            }
            catch (_g) {
                setTimeout(function () {
                    window.location.href = (isAutoRegMode
                        ? Constants.Routes.autoreg
                        : eventData.verbiage === "Tickets"
                            ? Constants.Routes.tickets
                            : Constants.Routes.register)
                        .replace(":clientKey", eventData.clientKey)
                        .replace(":urlKey", eventData.urlKey)
                        .replace(":lookupId?", "")
                        .replace(":eventNumber", eventData.eventNumber.toString());
                }, 2000);
            }
    };
    var navigateToEvent = function (relatedEvent) { return function (_evt, e) {
        e.preventDefault();
        e.stopPropagation();
        platformAwareRedirect(Constants.Routes.eventStart
            .replace(":clientKey", relatedEvent.clientKey)
            .replace(":urlKey", relatedEvent.urlKey)
            .replace(":eventNumber", relatedEvent.eventNumber.toString()), isWidget, history);
    }; };
    useEffect(function () {
        if (secondsLeft !== undefined) {
            if (secondsLeft > 1) {
                setTimeout(function () {
                    setSecondsLeft(secondsLeft - 1);
                }, 1000);
            }
            else {
                setTimeout(function () {
                    setSecondsLeft(0);
                    finishOrder();
                }, 1000);
            }
        }
    }, [secondsLeft]);
    var printTickets = function () {
        var iFrame = document.getElementById("js-pdf-iframe");
        if (iFrame) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            var iframe = document.frames
                ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    document.frames[id]
                : document.getElementById("js-pdf-iframe");
            var iframeWindow = iframe.contentWindow || iframe;
            iframe.focus();
            iframeWindow.print();
        }
    };
    if (!orderResult) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "order-results" }, { children: [_jsxs(Modal, __assign({ show: showModal, onHide: function () {
                            setShowModal(false);
                        }, centered: true }, { children: [!!(modalContent === null || modalContent === void 0 ? void 0 : modalContent.title) && (_jsx(Modal.Header, __assign({ closeButton: true }, { children: _jsx(Modal.Title, __assign({ id: "contained-modal-title-vcenter" }, { children: modalContent.title })) }))), !!modalContent && (_jsx(Modal.Body, { dangerouslySetInnerHTML: { __html: modalContent.html } }))] })), _jsx(Row, { children: _jsxs(Col, { children: [_jsx("h1", __assign({ className: "display ta-center mb-3" }, { children: _jsx(Icon, { icon: "check-circle", classes: "success ta-center" }) })), _jsx("h1", __assign({ className: "no-margin-top display tt-uppercase display ta-center" }, { children: "Thank you!" })), _jsxs("h3", __assign({ className: "tt-uppercase bold ta-center my-3" }, { children: ["Order ", orderResult.orderKey.toUpperCase(), " received!"] }))] }) }), !!orderResult.printUrl && (_jsx("iframe", { id: "js-pdf-iframe", title: "Print", name: "js-pdf-iframe", style: {
                            visibility: "hidden",
                            width: "200px",
                            height: "200px",
                            position: "absolute",
                            pointerEvents: "none",
                            marginLeft: "-200px",
                            opacity: 0,
                        }, onLoad: function () {
                            printTickets();
                        }, seamless: true, src: orderResult.printUrl })), !!orderResult.email && (_jsxs(_Fragment, { children: [_jsxs("h6", __assign({ className: "ta-center" }, { children: ["Email confirmation ", orderResult.isInKioskMode ? "has been" : "will be", " sent to", " ", _jsx("b", { children: orderResult.email }), "."] })), _jsx("br", {})] })), orderResult.queueIsDelayed === true && (_jsxs(_Fragment, { children: [_jsx("h2", { children: "Note: It may take up to an hour before you receive email confirmation or you are able to view your order online." }), _jsx("br", {})] })), (orderResult.hasSignatures || orderResult.hasGifts || orderResult.hasPreRegistered) && (_jsx(_Fragment, { children: orderResult.hasSignatures ? (_jsx(Alert, __assign({ icon: "edit", purpose: "primary", className: "m-top-medium alert-tight", title: "Electronic signature required to complete your\n\t\t\t\t\t\t\tregistration!" }, { children: _jsx("p", { children: "A separate email will be sent to each person who needs to sign. Please follow the instructions in the email to provide your signature and complete this registration." }) }))) : (_jsx(_Fragment, { children: orderResult.hasGifts ? (_jsx(Alert, __assign({ icon: "gift", purpose: "primary", className: "m-top-medium alert-tight", title: "Finish sending your gifts" }, { children: _jsxs(_Fragment, { children: [_jsxs("p", { children: ["Your order contains one or more gifts, but", " ", _jsx("b", { children: "they haven't been sent yet!" })] }), _jsx("p", { children: "Check your confirmation email for a link to send your gifts with a customizable message." })] }) }))) : (_jsx(Alert, __assign({ icon: "check-square", purpose: "primary", className: "m-top-medium alert-tight", title: "But your registrations aren't\n\t\t\t\t\t\t\t\t\tcomplete yet!" }, { children: _jsxs(_Fragment, { children: [_jsx("p", { children: "Your order contains one or more incomplete registrations and will need to be completed!" }), _jsx("p", { children: "Check your confirmation email for a link to manage your incomplete registrations." })] }) }))) })) })), orderResult.finishText && (_jsx("div", { className: orderResult.isInKioskMode
                            ? "alert alert-misc m-top-medium wysiwyg-text"
                            : "m-top-large wysiwyg-text", dangerouslySetInnerHTML: { __html: orderResult.finishText } })), _jsx(Form, __assign({ initialValues: {}, onSubmit: onSubmit, formikBagProps: {
                            submitButtonLabel: (orderResult === null || orderResult === void 0 ? void 0 : orderResult.anyGeneratesTicket) && isMobile
                                ? "View Tickets"
                                : ((_h = (_g = history === null || history === void 0 ? void 0 : history.location) === null || _g === void 0 ? void 0 : _g.state) === null || _h === void 0 ? void 0 : _h.postAttendeeOrder)
                                    ? "Return"
                                    : "Finish",
                            secondsLeft: secondsLeft,
                        }, useUnsavedPrompt: false }, { children: function (_a) {
                            var formikContext = _a.formikContext;
                            return (_jsx(WidgetFieldset, { children: _jsx(FormikContextListener, { currentPath: path, path: "".concat(Constants.Routes.results), formikContext: formikContext, active: true }) }));
                        } }))] })), (orderResult === null || orderResult === void 0 ? void 0 : orderResult.anyGeneratesTicket) && !isMobile && qrUrl && qrLink && (_jsx(Row, __assign({ className: "d-flex justify-content-center mb-3" }, { children: _jsxs(Col, __assign({ xs: "auto", className: "text-center" }, { children: [_jsx("a", __assign({ href: qrLink }, { children: _jsx("img", { src: qrUrl, alt: "Tickets QR Code", height: 300 }) })), _jsx("p", { children: "Scan to view your mobile tickets!" })] })) }))), eventData && eventData.relatedEvents.length > 0 && (_jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx("hr", { className: "pb-3" }), _jsx("h3", __assign({ className: "tt-uppercase bold ta-center my-4" }, { children: "Related Events" })), _jsx("div", __assign({ className: "event-card-order-results pt-3" }, { children: eventData.relatedEvents.map(function (relatedEvent, index) {
                            var imageUrl = relatedEvent.imageUrl, eventTitle = relatedEvent.eventTitle, dateInfo = relatedEvent.dateInfo, clientKey = relatedEvent.clientKey, urlKey = relatedEvent.urlKey, eventNumber = relatedEvent.eventNumber;
                            return (_jsx(EventCard, { event: {
                                    promoImageUrl: imageUrl,
                                    title: eventTitle,
                                    dateInfoList: [dateInfo],
                                    eventNumber: eventNumber,
                                    urlKey: urlKey,
                                    clientKey: clientKey,
                                    remainingText: "",
                                    soldOut: false,
                                    isSticky: false,
                                }, isWidget: isWidget, isLoading: false, onClick: navigateToEvent(relatedEvent) }, index));
                        }) }))] })))] }));
};
export default CartResult;
